<div class="box-pntd">
    <div class="logoMob">
        <!-- <a href="{{selectProduct.link}}"> -->
            <img src="{{selectProduct.img}}" title="{{selectProduct.img}}" alt="{{selectProduct.img}}" />
        <!-- </a> -->
    </div>
    <h1>{{selectProduct.h1}}</h1>
    <h2 class="d-none d-md-block">{{selectProduct.h2}}</h2>
    <div class="bullets-all d-none d-md-block">
        <div class="bullets" *ngFor="let slider of selectProduct.sliders">
            <div class="img-bullet">
                <img src="{{slider.img}}" title="Descuentos" alt="Descuentos" />
            </div>
            <div class="txt-bullet">
                <h3>{{slider.title}}</h3>
                <p>{{slider.txt}}</p>
            </div>						
        </div>
    </div>					
    <div id="carouselIndicators" class="carousel slide d-block d-md-none" data-ride="carousel">							
        <div class="carousel-inner">
            <div class="carousel-item " *ngFor="let slider of selectProduct.sliders; let i=index" [ngClass]="{'active': i==0}">
                <div class="bullets">
                    <div class="img-bullet">
                        <img src="{{slider.img}}" title="Descuentos" alt="Descuentos" />
                    </div>
                    <div class="txt-bullet">
                        <h3>{{slider.title}}</h3>
                        <p>{{slider.txt}}</p>
                    </div>						
                </div>
            </div>
        </div>
        <ol class="carousel-indicators">
            <li data-target="#carouselIndicators"*ngFor="let slider of selectProduct.sliders; let i=index" [ngClass]="{'active': i==0}" [attr.data-slide-to]="i"></li>
        </ol>
    </div>
</div>
